export const environment = {
    clientName: 'LambdastaticSmashApp',
    production: false,
    local: false,
    mock: false,
    hmr: true,
    prefixUrl: 'dev-',
    version: require('../../package.json').version,
    stripeKey: 'pk_test_F1MlHimhwqSjPOp6thBwZWkY',
    cgu: {
        version: require('../../package.json').cgu.version,
        updated: require('../../package.json').cgu.updated,
    },
    googleTagManagerId: 'GTM-TN9DT8V',
    googleTagManagerPreview: 'env-3',
    googleTagManagerAuth: 'xuwvRk_QCOlox01pvp1s5Q',
    additionalModules: [],
    hCaptchaSiteKey: 'ba0a4e20-838e-43d2-b290-f4baac083fca',
    appDomainWithProtocol: 'https://fromsmash.ninja',
    // Name an authenticator application displays for a Smash MFA entry. Per environment, so a test
    // enrolment is not indistinguishable from a production one in the user's authenticator.
    mfaAuthenticatorIssuer: 'Smash ninja',
    domainSdk: 'https://dev-domain.fromsmash.co',
    appDomain: 'fromsmash.ninja',
    discovery: 'https://dev-discovery.fromsmash.co',
    asset: "https://dev-asset.fromsmash.co",
    services: [
        {
            service: "SmashBilling:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-billing.ca-central-1.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-billing.eu-central-1.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-billing.eu-west-1.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-billing.eu-west-2.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-billing.eu-west-3.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-billing.us-east-1.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-billing.us-east-2.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-billing.us-west-1.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashBilling:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-billing.us-west-2.fromsmash.co",
            name: "billing"
        },
        {
            service: "SmashCaptcha:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-captcha.eu-west-1.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-captcha.eu-west-2.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-captcha.eu-west-3.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-captcha.eu-central-1.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-captcha.ca-central-1.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-captcha.us-west-1.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-captcha.us-west-2.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-captcha.us-east-1.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCaptcha:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-captcha.us-east-2.fromsmash.co",
            name: "captcha"
        },
        {
            service: "SmashCustomization:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-customization.ca-central-1.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-customization.eu-central-1.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-customization.eu-west-1.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-customization.eu-west-2.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-customization.eu-west-3.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-customization.us-east-1.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-customization.us-east-2.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-customization.us-west-1.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashCustomization:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-customization.us-west-2.fromsmash.co",
            name: "customization"
        },
        {
            service: "SmashDirectory:dev",
            region: "global",
            url: "https://dev-directory.fromsmash.co",
            name: "directory"
        },
        {
            service: "SmashDiscovery:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-discovery.ca-central-1.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-discovery.eu-central-1.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-discovery.eu-west-1.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-discovery.eu-west-2.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-discovery.eu-west-3.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-discovery.us-east-1.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-discovery.us-east-2.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-discovery.us-west-1.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDiscovery:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-discovery.us-west-2.fromsmash.co",
            name: "discovery"
        },
        {
            service: "SmashDomain:dev",
            region: "global",
            url: "https://dev-domain.fromsmash.co",
            name: "domain"
        },
        {
            service: "SmashGnitekram:dev:ca-central-1",
            region: "global",
            url: "https://dev-gnitekram.fromsmash.co",
            name: "gnitekram"
        },
        {
            service: "SmashScitylana:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-scitylana.ca-central-1.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-scitylana.eu-central-1.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-scitylana.eu-west-1.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-scitylana.eu-west-2.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-scitylana.eu-west-3.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-scitylana.us-east-1.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-scitylana.us-east-2.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-scitylana.us-west-1.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashScitylana:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-scitylana.us-west-2.fromsmash.co",
            name: "scitylana"
        },
        {
            service: "SmashIam:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-iam.ca-central-1.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-iam.eu-central-1.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-iam.eu-west-1.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-iam.eu-west-2.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-iam.eu-west-3.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-iam.us-east-1.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-iam.us-east-2.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-iam.us-west-1.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashIam:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-iam.us-west-2.fromsmash.co",
            name: "iam"
        },
        {
            service: "SmashImage:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-image.ca-central-1.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-image.eu-central-1.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-image.eu-west-1.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-image.eu-west-2.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-image.eu-west-3.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-image.us-east-1.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-image.us-east-2.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-image.us-west-1.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashImage:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-image.us-west-2.fromsmash.co",
            name: "image"
        },
        {
            service: "SmashKyc:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-kyc.ca-central-1.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-kyc.eu-central-1.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-kyc.eu-west-1.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-kyc.eu-west-2.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-kyc.eu-west-3.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-kyc.us-east-1.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-kyc.us-east-2.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-kyc.us-west-1.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashKyc:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-kyc.us-west-2.fromsmash.co",
            name: "kyc"
        },
        {
            service: "SmashLink:dev",
            region: "global",
            url: "https://dev-link.fromsmash.co",
            name: "link"
        },
        {
            service: "SmashPlugin:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-plugin.ca-central-1.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-plugin.eu-central-1.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-plugin.eu-west-1.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-plugin.eu-west-2.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-plugin.eu-west-3.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-plugin.us-east-1.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-plugin.us-east-2.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-plugin.us-west-1.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPlugin:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-plugin.us-west-2.fromsmash.co",
            name: "plugin"
        },
        {
            service: "SmashPromotion:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-promotion.ca-central-1.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-promotion.eu-central-1.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-promotion.eu-west-1.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-promotion.eu-west-2.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-promotion.eu-west-3.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-promotion.us-east-1.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-promotion.us-east-2.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-promotion.us-west-1.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashPromotion:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-promotion.us-west-2.fromsmash.co",
            name: "promotion"
        },
        {
            service: "SmashTheme:dev",
            region: "global",
            url: "https://dev-theme.fromsmash.co",
            name: "theme"
        },
        {
            service: "SmashSquarespace:dev",
            region: "global",
            url: "https://dev-squarespace.fromsmash.co",
            name: "squarespace"
        },
        {
            service: "SmashTransfer:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-transfer.ca-central-1.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-transfer.eu-central-1.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-transfer.eu-west-1.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-transfer.eu-west-2.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-transfer.eu-west-3.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-transfer.us-east-1.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-transfer.us-east-2.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-transfer.us-west-1.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashTransfer:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-transfer.us-west-2.fromsmash.co",
            name: "transfer"
        },
        {
            service: "SmashVat:dev:ca-central-1",
            region: "ca-central-1",
            url: "https://dev-vat.ca-central-1.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:eu-central-1",
            region: "eu-central-1",
            url: "https://dev-vat.eu-central-1.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:eu-west-1",
            region: "eu-west-1",
            url: "https://dev-vat.eu-west-1.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:eu-west-2",
            region: "eu-west-2",
            url: "https://dev-vat.eu-west-2.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:eu-west-3",
            region: "eu-west-3",
            url: "https://dev-vat.eu-west-3.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:us-east-1",
            region: "us-east-1",
            url: "https://dev-vat.us-east-1.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:us-east-2",
            region: "us-east-2",
            url: "https://dev-vat.us-east-2.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:us-west-1",
            region: "us-west-1",
            url: "https://dev-vat.us-west-1.fromsmash.co",
            name: "vat"
        },
        {
            service: "SmashVat:dev:us-west-2",
            region: "us-west-2",
            url: "https://dev-vat.us-west-2.fromsmash.co",
            name: "vat"
        }
    ],
    // smash-telemetry configuration (front-end error/console/Web Vitals observability).
    telemetry: {
        logGroup: 'lambdastatic-smash-app',
        stream: 'dev',
        baseUrl: 'https://dev-log.fromsmash.co',
        enabled: true,
    },
};
